export default function Loader() {
  return (
    <div className="flex w-full h-full items-center justify-center bg-white">
      <div
        className={`w-16 h-16 border-4 border-t-4 border-l-4 border-x-castell border-castellpastel-200 rounded-full animate-spin`}
      />
    </div>
  );
}
